var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{domProps:{"textContent":_vm._s(_vm.timer > 0 ? `(${_vm.timer})` : '')}})
}
var staticRenderFns = []

export { render, staticRenderFns }